

/** Profile */
export const setProfileAction = (payload) => {
    return {
        type: "SET_PROFILE",
        payload
    }
};